import { CategoriesPropType } from "../types";

type PropType = {
  category: CategoriesPropType;
};

const CategoryCard = ({ category }: PropType) => {
  return (
    <div className="rounded-md shadow-lg border text-black cursor-pointer border-primary/20 bg-white flex flex-col items-center p-4 px-6 gap-4">
      <div
        className="w-10 md:w-28 h-10 md:h-28 bg-green-300 rounded-full shadow-xl bg-center bg-cover bg-no-repeat "
        style={{ backgroundImage: `url(${category.image})` }}
      ></div>
      <div className="whitespace-nowrap text-xs xl:text-base font-medium">
        {category?.name}
      </div>
    </div>
  );
};

export default CategoryCard;
